import { render } from "./SectionStart.vue?vue&type=template&id=aa3ebb56"
import script from "./SectionStart.vue?vue&type=script&lang=js"
export * from "./SectionStart.vue?vue&type=script&lang=js"
script.render = render

export default script